import { create } from "zustand";
import { Button, Card, Space, Modal, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import DataListStore from "store/DataListStore";
import ListViewV2 from "../DataListV2";
import { useRef, useState } from "react";
import {
  ProForm,
  ProFormText,
  ProFormTextArea,
} from "@ant-design/pro-components";
import { RequestProsesResi } from "services/datalist/datalist-api";

const resiTrackingStore = create(DataListStore);

function ProsesPacking(props) {
  const formRef = useRef();
  const [isModalOpen, setModalOpen] = useState(false);
  const [resiValue, setResiValue] = useState("");
  const [listResi, setListResi] = useState([]);

  const [reloader, setReloader] = useState(false);

  const divRef = useRef();

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const onModalOK = () => {
    console.log(formRef);
    formRef.current.submit();
    closeModal();
  };

  return (
    <Card
      title={
        <strong>
          <h1>Proses Packing</h1>
        </strong>
      }
    >
      <Space
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Button type="primary" onClick={openModal} size="large">
          <Space>
            <PlusOutlined /> Proses Scan Resi Packing
          </Space>
        </Button>
        <p>Proses scan resi telah dipacking</p>
      </Space>

      <Modal
        title="Scan Resi"
        open={isModalOpen}
        onOk={onModalOK}
        onCancel={closeModal}
      >
        <ProForm
          formRef={formRef}
          submitter={false}
          onFinish={async (val) => {
            console.log(val, listResi);
            formRef.current.resetFields();
            if (listResi.length > 0) {
              await RequestProsesResi({
                mode: "Packing",
                resi: listResi,
                keterangan: "",
              });

              setReloader(!reloader);

              notification.success({
                message: "Success",
              });
            }
            setListResi([]);
            setResiValue("");
          }}
          onKeyDown={(e) => {
            let noResi = formRef.current.getFieldValue("no");
            if (e.key === "Enter" && noResi) {
              let newList = listResi;
              newList.push(noResi);
              setListResi(newList);
              setResiValue(newList.join("\n"));
              formRef.current.setFieldValue("no", "");
              divRef.current.scrollTop = divRef.current.scrollHeight - 10;
            }
          }}
        >
          <ProFormText name={"no"} label="Masukan No. Resi" />
          <p>
            List Scan Resi : <strong>Total {listResi.length}</strong>
          </p>
          <div
            ref={divRef}
            style={{
              minHeight: "180px",
              maxHeight: "400px",
              overflow: "scroll",
            }}
          >
            <ProFormTextArea
              name={"listResi"}
              readonly={true}
              fieldProps={{ value: resiValue, rows: 8 }}
            />
          </div>
        </ProForm>
      </Modal>

      <br />
      <ListViewV2
        viewId="trackingpacking"
        store={resiTrackingStore}
        hideTitle={true}
        reloader={reloader}
      />
    </Card>
  );
}

export default ProsesPacking;
